@if (isVisible) {
  <div class="confirmation-overlay" (click)="onOverlayClick()">
    <div #dialogue class="confirmation-dialog" role="alertdialog" aria-modal="true"
      aria-labelledby="confirmation-titre" aria-describedby="confirmation-message"
      (click)="$event.stopPropagation()" (keydown)="clavier($event)">
      <div class="dialog-icon" [ngClass]="getIconClass()" aria-hidden="true">
        <i [class]="options?.icon || 'pi pi-exclamation-triangle'"></i>
      </div>
      <div class="dialog-content">
        <h2 id="confirmation-titre" class="dialog-title">{{ options?.title }}</h2>
        <p id="confirmation-message" class="dialog-message">{{ options?.message }}</p>
        <!-- NEW: Select field -->
        @if (options?.selectOptions) {
          <div class="select-field">
            @if (options?.selectLabel) {
              <label for="confirmation-choix">{{ options?.selectLabel }}</label>
            }
            <select id="confirmation-choix" [(ngModel)]="selectedChoice" class="custom-select">
              <option [value]="null" disabled selected>{{ options?.selectPlaceholder || ('COMMON.SELECT' | translate) }}
              </option>
              @for (opt of options?.selectOptions; track opt) {
                <option [ngValue]="opt.value">{{ opt.label }}</option>
              }
            </select>
            @if (options?.selectRequired && !selectedChoice && submitted) {
              <p class="error-text">{{ 'MESSAGES.REQUIRED_FIELD' | translate }}</p>
            }
          </div>
        }
        <!-- NEW: Date input fields -->
        @if (options?.dateInputLabel) {
          <div class="input-field" style="text-align: left; margin-top: 1rem;">
            <label for="confirmation-date"
              style="display: block; font-weight: 600; color: #475569; margin-bottom: 0.5rem; font-size: 0.875rem;">{{
            options?.dateInputLabel }}</label>
            <input type="date" id="confirmation-date" [(ngModel)]="dateInput" class="custom-input"
              style="width: 100%; padding: 0.75rem; border-radius: 8px; border: 1px solid #e2e8f0; background-color: #f8fafc; font-size: 1rem; color: #1e293b; outline: none;">
          </div>
        }
        @if (options?.dateInput2Label) {
          <div class="input-field" style="text-align: left; margin-top: 1rem;">
            <label for="confirmation-date2"
              style="display: block; font-weight: 600; color: #475569; margin-bottom: 0.5rem; font-size: 0.875rem;">{{
            options?.dateInput2Label }}</label>
            <input type="date" id="confirmation-date2" [(ngModel)]="dateInput2" class="custom-input"
              style="width: 100%; padding: 0.75rem; border-radius: 8px; border: 1px solid #e2e8f0; background-color: #f8fafc; font-size: 1rem; color: #1e293b; outline: none;">
          </div>
        }
        <!-- NEW: Text input field -->
        @if (options?.inputLabel) {
          <div class="input-field" style="text-align: left; margin-top: 1rem;">
            <label for="confirmation-texte"
              style="display: block; font-weight: 600; color: #475569; margin-bottom: 0.5rem; font-size: 0.875rem;">{{
            options?.inputLabel }}</label>
            <input type="text" id="confirmation-texte" [(ngModel)]="textInput" [placeholder]="options?.inputPlaceholder || ''"
              class="custom-input"
              style="width: 100%; padding: 0.75rem; border-radius: 8px; border: 1px solid #e2e8f0; background-color: #f8fafc; font-size: 1rem; color: #1e293b; outline: none;">
            @if (options?.inputRequired && !textInput && submitted) {
              <p class="error-text">{{ 'MESSAGES.REQUIRED_FIELD' | translate }}</p>
            }
          </div>
        }
      </div>
      <div class="dialog-actions">
        <button type="button" class="btn-cancel" (click)="onCancel()">
          <i class="pi pi-times" aria-hidden="true"></i>
          {{ options?.cancelText || ('COMMON.CANCEL' | translate) }}
        </button>
        <button type="button" class="btn-confirm" [ngClass]="getConfirmButtonClass()" (click)="onConfirm()"
          [disabled]="(options?.selectRequired && !selectedChoice) || (options?.inputRequired && !textInput)">
          <i [class]="options?.icon ? options!.icon : 'pi pi-check'" aria-hidden="true"></i>
          {{ options?.confirmText || ('COMMON.CONFIRM' | translate) }}
        </button>
      </div>
    </div>
  </div>
}